import type { SubmitFeedbackRequest, SubmitFeedbackResult } from '../types/feedback';

const API_URL = import.meta.env.VITE_API_URL || '';

/**
 * Submit feedback to the backend API.
 * Works in both browser mode and desktop app mode.
 */
export async function submitFeedback(
  request: SubmitFeedbackRequest
): Promise<SubmitFeedbackResult> {
  if (!API_URL) {
    return {
      success: false,
      error: 'API URL is not configured',
    };
  }

  try {
    const response = await fetch(`${API_URL}/submit-feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.error || `Request failed with status ${response.status}`,
      };
    }

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to submit feedback',
    };
  }
}

/**
 * Open a URL in the system's default browser.
 * Uses Electron API in desktop mode, falls back to window.open in browser mode.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (window.electronAPI?.openExternalUrl) {
    await window.electronAPI.openExternalUrl(url);
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
